/**
 * config.
 *
 * Configuration parameters for developers
 *
 * @file   This files defines the consts.
 * @author Ellen Vanhove.
 */

export const MEDIA = '/static/blocks-media/';


//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = 48
// module chunks = 0